export default __webpack_public_path__ + "static/media/course6.dddb1e15.webp";